// ./src/config/layoutEditorUiConfig.ts

export const layoutEditorUiConfig = [
  // General section commented out - only columns mode supported for now
  // {
  //   sectionName: "General",
  //   sectionKey: "general",
  //   description: "General layout settings",
  //   groups: [
  //     {
  //       groupName: "Layout Type",
  //       elements: [
  //         {
  //           label: "Layout Type",
  //           accessAs: "layoutType",
  //           component: "Select",
  //           default: "columns",
  //           description: "Choose between columns or grid layout",
  //           options: {
  //             data: [
  //               { value: "columns", label: "Columns" },
  //               { value: "grid", label: "Grid" },
  //             ],
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    sectionName: "Header",
    sectionKey: "header",
    description: "Header section configuration",
    groups: [
      {
        groupName: "Header Settings",
        elements: [
          {
            label: "Hide on no content",
            accessAs: "header.autoHide",
            component: "Switch",
            default: true,
            //description: "Hide header on no content to show",
          },
          {
            label: "Height",
            accessAs: "header.height",
            component: "HeightSelector",
            default: "3.75rem",
            description: "Header height",
          },
        ],
      },
      {
        groupName: "Header Components",
        elements: [
          {
            label: "Components",
            accessAs: "header.components",
            component: "ComponentsEditor",
            default: [],
            description: "Configure components displayed in the header",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Main",
    sectionKey: "main",
    description: "Main content area configuration",
    groups: [
      {
        groupName: "Main Settings",
        elements: [
          {
            label: "Gap Between Zones",
            accessAs: "main.gap",
            component: "GapSelector",
            default: "16px",
            description: "Spacing between zones",
          },
        ],
      },
      {
        groupName: "Content Zones",
        elements: [
          {
            label: "Zones",
            accessAs: "main.zones",
            component: "ZonesEditor",
            default: [],
            description: "Configure content zones in the main area",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Footer",
    sectionKey: "footer",
    description: "Footer section configuration",
    groups: [
      {
        groupName: "Footer Settings",
        elements: [
          {
            label: "Hide on no content",
            accessAs: "footer.autoHide",
            component: "Switch",
            default: true,
            //description: "Hide footer on no content to show",
          },
          {
            label: "Height",
            accessAs: "footer.height",
            component: "HeightSelector",
            default: "3.75rem",
            description: "Footer height",
          },
        ],
      },
      {
        groupName: "Footer Components",
        elements: [
          {
            label: "Components",
            accessAs: "footer.components",
            component: "ComponentsEditor",
            default: [],
            description: "Configure components displayed in the footer",
          },
        ],
      },
    ],
  },
];
